/** Localiza "Nth Prize" a EN/FR/PT-PT según el número */
export const localizePrizeLabel = (input: string | number, locale = 'en') => {
	// Acepta "8th Prize", "Prize 8", "8", etc.
	const n = typeof input === 'number' ? input : parseInt(String(input).match(/\d+/)?.[0] ?? '', 10)

	if (!Number.isFinite(n)) return String(input) // fallback si no hay número

	switch (locale) {
		case 'fr':
			// "prix" (masculino). 1 -> "1er prix", resto -> "2e prix", "8e prix", etc.
			return n === 1 ? '1er prix' : `${n}e prix`

		case 'pt':
			// Portugués de Portugal (masculino): "1.º prémio", "2.º prémio", ...
			// OJO: "prémio" lleva acento en PT-PT.
			return `${n}.º prémio`

		case 'en':
		default:
			return input
	}
}
